<!-- orderConfirm -->
<template>
  <div class="orderConfirm" :class="['orderConfirm', { inApp: $root.$data.isApp || this.$root.miniprogram }]">
    <common-title titleName="确认订单" :beforeExec="goBackConfirm" :zIndex="1000"></common-title>
    <p v-if="unionSelectable" class="unionPromotion cardPart" @click="unionSelect">
      <span v-if="unionRecommendAmount" class="promotionName">联报更优惠，可立减{{ unionRecommendAmount }}元</span>
    </p>
    <order-confirm-addresss v-if="orderCheckInfo.needAddress" :addressInfo="addressInfo" @click="addressSelect" />
    <p class="agreement"></p>
    <section class="productList cardPart">
      <p class="productListTitle cardPartTitle">订单信息</p>
      <CartProductList v-if="$route.query.cart" :productList="packageFlagList" :memberPackage="memberPackage"
        :hasDirectAccommodation="hasDirectAccommodation" />
      <product-list v-else :packageFlag="packageFlag" :productList="productList" :packageDetail="packageDetail"
        :memberPackage="memberPackage" :hasDirectAccommodation="hasDirectAccommodation" />
    </section>
    <section class="promotion cardPart">
      <p class="promotionTitle cardPartTitle">优惠信息</p>
      <promotion-list :promotionList="promotionList" :memberPackage="memberPackage" :couponName="couponName"
        :couponList="couponAllList" @selectCoupon="selectCoupon" />
    </section>
    <bottom-button-group :payable="priceInfo.payable" :totalDiscount="priceInfo.totalDiscount"
      :orderCommitLoading="orderCommitLoading" @goCashier="orderCommit" />
    <go-back-window :dialogShow="dialogShow" @close="dialogClose"></go-back-window>
    <coupon-select :couponSelectShow="couponSelectShow" :couponAllList="couponAllList" :recommendInfo="couponInfo"
      @couponSelect="couponSelect" @close="popupClose" />
    <joint-preferences-detail ref="jointPreferencesRef" :showAcvitity="unionSelectShow"
      :defaultSelectCourse="defaultSelectCourse" :activityData="unionData" @unionConfirm="unionConfirm" />
    <CommonLoading :loading="loading" />
    <div class="secondSKillTips" v-show="skillFlag">秒杀课程不参与其他优惠</div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';

// eslint-disable-next-line import/no-cycle
import {
  reqOrderProductCheck,
  reqOrderProductInfo,
  reqOrderPriceInfo,
  postOrderCommit,
  reqUnionRecommend,
  reqUserOrderCouponList,
  postGroupCommit,
  reqPostGroupPrice,
  reqPostGroupJoinCommit,
} from '@/api/pay';
import { reqAddressList } from '@/api/personal/addressController';
import { COUPON_TYPE, labelMap } from '@/assets/js/payConfig';
import { reqCombinationDetail } from '@/api/combination';
import JointPreferencesDetail from '@/components/jointPreferences/jointPreferencesDetail.vue';
import CommonLoading from '@/components/commonComponents/CommonLoading.vue';
import { gioPlatform, statusTextMap } from '@/utils/tools';
import { reqPackageName } from '@/api/courseDetail/shoppingCar/shoppingCar';
import OrderConfirmAddresss from './orderConfirmComponents/orderConfirmAddress.vue';
import ProductList from './orderConfirmComponents/productList.vue';
import PromotionList from './orderConfirmComponents/promotionList.vue';
import CouponSelect from './orderConfirmComponents/couponSelect.vue';
import goBackWindow from './orderConfirmComponents/goBackWindow.vue';
import bottomButtonGroup from './orderConfirmComponents/bottomButtonGroup.vue';
import CartProductList from './orderConfirmComponents/cartProductList.vue';

export default {
  data() {
    return {
      productList: [],
      promotionList: [],
      couponAllList: [],
      couponInfo: {},
      priceInfo: {
        payable: '0',
        totalDiscount: '0',
      },
      dialogShow: false,
      couponSelectShow: false,
      unionSelectable: false,
      couponName: '',
      orderCheckInfo: {
        addressBeforeOrder: false,
        needAddress: false,
        repeatPurchaseProductId: [],
      },
      addressInfo: {
        id: '',
        userName: '',
        userPhone: '',
        userAddress: '',
      },
      unionRecommendAmount: 0,
      labelInfo: {},
      unionSelectShow: false,
      defaultSelectCourse: [],
      unionData: {},
      isInUnion: false,
      orderCommitLoading: false,
      routeQuery: JSON.parse(this.$route.query.product)[0],
      referer: '',
      loading: true,
      skillFlag: false,
      packageDetail: {},
      packageFlag: '',
      gioVisitUserId: '',
      priceInfoBox: {},
      gioOrderId: '', // 埋点数据 订单id
      skuList: [], // 选中的sku
      packageList: [],
      packageFlagList: [], // 结算的套餐列表带标签
      memberPackage: true,
      hasDirectAccommodation: false
    };
  },
  components: {
    OrderConfirmAddresss,
    ProductList,
    PromotionList,
    CouponSelect,
    goBackWindow,
    bottomButtonGroup,
    JointPreferencesDetail,
    CommonLoading,
    CartProductList,
  },
  mounted() {
    this.dataInit(true);
    this.getDeatil();

    if (this.$root.$data.isApp) {
      this.$sendToApp('getGIoVisitUserId', false);
    }
    window.setGIoVisitUserId = (value) => {
      this.getAndroid(value);
    };
    this.setQuestionCallBackUrl(); // 设置题库跳转过来的回调地址
  },
  methods: {
    // 设置题库跳转过来的回调地址
    setQuestionCallBackUrl() {
      if (this.$route.query.questionCallbackUrl) {
        sessionStorage.setItem('questionCallBackUrl', this.$route.query.questionCallbackUrl);
      }
    },
    getAndroid(value) {
      if (this.$root.$data.isApp) {
        this.gioVisitUserId = `{u:'${value || ''}', roomId: '${this.$route.query.liveRoomId || ''
          }',wechatSource:'${this.miniParams()}'}`;
      }
    },
    async dataInit(isInit, productSkus) {
      const selectedProductSkus = productSkus || JSON.parse(this.$route.query?.product || '[]');
      await this.orderProductCheck(selectedProductSkus);

      await Promise.all([
        this.getProductInfo(selectedProductSkus),
        this.getCouponInfo(selectedProductSkus),
      ]);
      this.getPriceInfo(isInit, selectedProductSkus);
    },
    async orderProductCheck(selectedProductSkus) {
      try {
        const { cart } = this.$route.query;
        let checkResult = '';
        if (cart) {
          // 购物车多套餐购买
          const products = [];
          selectedProductSkus.map((item) => {
            item.packageProductSkuReqList.map((productInfo) => {
              products.push({
                productId: productInfo.productId,
                productSkuId: productInfo.skuId,
                quantity: 1,
                type: 1,
                promotion: '',
                userId: this.$store.state.userInfo.id,
              });
            });
          });
          checkResult = await reqOrderProductCheck({
            products,
            userId: this.$store.state.userInfo.id,
          });
        } else {
          checkResult = await reqOrderProductCheck({
            products: selectedProductSkus.map((productInfo) => ({
              productId: productInfo.productId,
              productSkuId: productInfo.skuId,
              quantity: 1,
              type: 1,
              promotion: '',
              userId: this.$store.state.userInfo.id,
            })),
            userId: this.$store.state.userInfo.id,
          });
        }

        if (checkResult?.code) {
          throw new Error(
            checkResult?.msg ||
            checkResult?.errorData?.[0]?.msg ||
            `code: ${checkResult?.code}, 请求失败`,
          );
        } else {
          Object.assign(this.orderCheckInfo, checkResult?.data || {});
          if (this.orderCheckInfo.needAddress) {
            this.getAddressInfo();
          }
          if (checkResult?.data?.repeatPurchaseProductId?.length) {
            this.$toast(
              `id为${checkResult?.data?.repeatPurchaseProductId.join()}的产品不可重复购买,请重新下单`,
            );
            // this.$router.replace('/');
          }
        }
      } catch (e) {
        this.$toast(`${e},订单商品校验失败`);
      }
    },

    async getProductInfo(selectedProductSkus) {
      const { cart } = this.$route.query;
      try {
        let responseJSON = '';
        if (cart) {
          const products = [];
          selectedProductSkus.map((item) => {
            item.packageProductSkuReqList.map((productInfo) => {
              products.push(productInfo);
            });
          });
          this.skuList = products;
          responseJSON = await reqOrderProductInfo(products);
        } else {
          this.skuList = selectedProductSkus;
          responseJSON = await reqOrderProductInfo(selectedProductSkus);
        }
        if (responseJSON?.code) {
          throw new Error(responseJSON?.errorData || '请求错误');
        }
        this.hasAccommodationProduct(responseJSON?.data)
        // 判断课程id 是否有重复的
        if (this.NewgetRepeat(this.skuList)) {
          // 筛选地址传输过来的sku

          const originalList = [];

          // eslint-disable-next-line no-unused-expressions
          responseJSON?.data?.map((product) => {
            (product?.productSkuRespVOList || []).map((sku) => {
              this.skuList.map((productSku) => {
                if (sku.productSkuId === Number(productSku.skuId)) {
                  originalList.push({
                    name: product.name,
                    price: sku.price || product.sellPrice,
                    productId: product.id,
                    productSkuId: sku.productSkuId,
                    promotion: '',
                    specs: sku.isDefault
                      ? []
                      : JSON.parse(sku?.specJson || '[]')?.map((val) => val.value),
                  });
                }
              });
            });
          });

          this.productList = this.unique(originalList);
        } else {
          // 筛选地址传输过来的sku
          this.productList = !responseJSON?.code
            ? responseJSON?.data?.map((product) => {
              const selectedProductSku =
                (product?.productSkuRespVOList || []).find(
                  (sku) =>
                    sku.productSkuId ===
                    (
                      this.skuList.find(
                        (productSku) => Number(productSku.productId) === Number(product.id),
                      ) || {}
                    ).skuId,
                ) || {};
              return {
                name: product.name,
                price: selectedProductSku.price || product.sellPrice,
                productId: product.id,
                productSkuId: selectedProductSku.productSkuId,
                promotion: '',
                specs: selectedProductSku.isDefault
                  ? []
                  : JSON.parse(selectedProductSku?.specJson || '[]')?.map((item) => item.value),
              };
            })
            : [];
        }

        if (cart) {
          this.getPackageName();
        }
      } catch (e) {
        this.$toast(`因${e}订单产品初始化失败，请重试`);
      }
    },
    // 去重复
    unique(arr) {
      for (let i = 0; i < arr.length - 1; i++) {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i].productSkuId == arr[j].productSkuId) {
            arr.splice(j, 1);
            // 因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
            j--;
          }
        }
      }
      return arr;
    },

    //  判断一个数组中所有对象的某个属性值是否相同
    getRepeat(arr) {
      const set = new Set(); // 创建个集合Set对象（用object对象也可以）
      for (let i = 0; i < arr.length; i++) {
        if (set.has(arr[i].id)) {
          // 判断每个对象里number属性的值是否在集合Set
          return true; // 判断为true时提前退出pf函数
        }
        set.add(arr[i].id); // 将number属性的值添加到集合Set中
      }
      return false;
    },
    // 切换判断数据源为链接上的参数
    NewgetRepeat(arr) {
      const set = new Set(); // 创建个集合Set对象（用object对象也可以）
      for (let i = 0; i < arr.length; i++) {
        if (set.has(arr[i].productId)) {
          // 判断每个对象里number属性的值是否在集合Set
          return true; // 判断为true时提前退出pf函数
        }
        set.add(arr[i].productId); // 将number属性的值添加到集合Set中
      }
      return false;
    },
    async getCouponInfo(selectedProductSkus) {
      const { cart } = this.$route.query;
      const paramData = {
        fitEndPoint: 2,
        fitPlatform: 1,
        userId: this.$store.state.userInfo.id,
      };
      if (cart) {
        selectedProductSkus.map((item) => {
          Object.assign(item, {
            productInfos: item.packageProductSkuReqList,
          });
        });
        paramData.packageInfos = selectedProductSkus;
      } else {
        const { packageId } = this.$route.query;
        if (packageId) {
          paramData.packageInfos = [
            {
              packageId,
              productInfos: selectedProductSkus.map((productInfo) => ({
                productId: productInfo.productId,
                skuId: productInfo.skuId,
              })),
            },
          ];
        } else {
          paramData.productInfos = selectedProductSkus.map((productInfo) => ({
            productId: productInfo.productId,
            skuId: productInfo.skuId,
          }));
        }
      }
      try {
        const responseJSON = await reqUserOrderCouponList(paramData);
        if (responseJSON?.code) {
          throw new Error(responseJSON?.msg || '请求错误');
        }
        const couponList = responseJSON?.data || [];
        couponList.forEach((couponInfo) => {
          // couponInfo.active = false;
          Object.assign(couponInfo, {
            active: false,
            dateTimeInfo: `有效期至：${couponInfo.expireTime}`,
            expireTimestamp: new Date(couponInfo.expireTime).getTime(),
          });
        });
        if (couponList.length && !window.currentTimer) {
          this.$root.currentTimeUpdate();
        }
        this.couponAllList = couponList;
      } catch (e) {
        this.$toast(`因${e}获取优惠券列表错误`);
      }
    },
    // 产品活动标签
    labelCalc() {
      const labelTypeList = Object.keys(this.labelInfo);
      if (!labelTypeList?.length || !this.productList?.length) return;
      labelTypeList.forEach((labelType) => {
        (this.labelInfo?.[labelType] || []).forEach((promotedProduct) => {
          this.productList.find(
            (product) =>
              product.productId === promotedProduct.productId &&
              product.productSkuId === promotedProduct.skuId,
          ).promotion =
            labelMap?.[labelType]?.[promotedProduct.promotionLabel] || labelMap?.[labelType] || '';
        });
      });
      this.productList.sort((left, right) => left.promotion?.length - right.promotion?.length);
    },
    async reqUnionRecommend() {
      if (this.$route.query.cart) return;
      if (this.$route.query.packageId) return;
      try {
        const selectedProductSkus = JSON.parse(this.$route.query?.product || '[]');
        const handledProductSkus = selectedProductSkus.map((productSku) => ({
          productId: Number(productSku.productId),
          skuId: productSku.skuId,
        }));
        const unionRecommend = await reqUnionRecommend(handledProductSkus);
        this.unionRecommendAmount = unionRecommend?.data?.maxUnionDiscountPrice || 0;
        this.unionSelectable =
          !this.isInUnion && !!unionRecommend?.data?.promotionProductRespList?.length;
        this.defaultSelectCourse = handledProductSkus;
        this.unionData = unionRecommend?.data;
      } catch (e) {
        this.$toast(`${e}联报推荐初始化失败`);
      }
    },
    async getAddressInfo() {
      try {
        const addressListResponse = await reqAddressList({ pageNum: 0, pageSize: 100 });
        if (addressListResponse?.code) {
          this.$toast(`${addressListResponse?.msg}用户地址列表初始化失败`);
        }
        const addressList = addressListResponse?.data?.data || [];
        const addressId = Number(sessionStorage.getItem('addressId') || undefined);
        this.addressInfo = addressList.find((addressInfo) => addressInfo.id === addressId) || {};
        if (this.addressInfo.id) return;
        if (addressId) {
          x
          this.$toast('未找到您选择的地址，请确保地址修改后保存成功');
        }
        this.addressInfo = addressList.find((address) => address.type);
      } catch (e) {
        this.$toast(`${e}用户地址列表初始化失败`);
      }
    },
    priceHandle(promotionInfo = {}) {
      this.priceInfoBox = promotionInfo;
      Object.assign(this.couponInfo, {
        couponId: promotionInfo?.couponId || undefined,
        couponVersionId: promotionInfo?.couponVersionId || undefined,
        couponName: promotionInfo?.couponName || '',
      });
      (
        this.couponAllList.find((coupon) => coupon.couponId === promotionInfo?.couponId) || {}
      ).active = true;
      // console.log(promotionInfo, 'abc');
      const skillList = promotionInfo.singleCalculateResultRespList;
      // console.log(skillList);
      // eslint-disable-next-line
      skillList?.some((item) => {
        if (item.promotionLabel === 2 || item.promotionLabel === 3) {
          this.skillFlag = true;
          return true; // 跳出循环
        }
      });
      const { cart } = this.$route.query;
      if (cart) {
        this.packageList.map((product) => {
          product.packageProductSkuReqList.map((val) => {
            (promotionInfo.singlePackageCalculateResultRespList || []).forEach((item) => {
              item.packageDetailCalculateResultRespList.map((pack) => {
                if (val.skuId === pack.skuId) {
                  if (item.promotionLabel === 1) {
                    // this.packageFlag = '折后价';
                    Object.assign(product, {
                      packageLabel: '折后价',
                    });
                  } else if (item.promotionLabel === 3 || item.promotionLabel === 2) {
                    // this.packageFlag = '秒杀';
                    Object.assign(product, {
                      packageLabel: '秒杀',
                    });
                  }
                }
              });
            });
          });
        });
        this.packageFlagList = this.packageList;
      } else {
        (promotionInfo.singlePackageCalculateResultRespList || []).forEach((item) => {
          if (item.promotionLabel === 1) {
            this.packageFlag = '折后价';
          } else if (item.promotionLabel === 3 || item.promotionLabel === 2) {
            this.packageFlag = '秒杀';
          }
        });
      }

      this.promotionList = [
        {
          price: promotionInfo.couponDiscountPrice || 0,
          type: 'coupon',
          available: true,
          couponName: '',
          isRecommend:
            promotionInfo.couponId === this.couponInfo.recommend &&
            this.couponAllList.length &&
            promotionInfo.couponId,
        },
        {
          price: promotionInfo.unionDiscountPrice,
          type: 'union',
        },
        {
          price: promotionInfo.singleDiscountPrice,
          type: 'single',
        },
        {
          price: promotionInfo.fullDiscountPrice,
          type: 'discount',
        },
      ];
      console.log('??????', promotionInfo)
      // 如果单个产品 且 无套餐 才计算砍价
      const { bargainActualPrice, bargainDiscountPrice, orderPayPrice, productCalculateResultRespList, productPackageCalculateResultRespList } = promotionInfo
      if (productCalculateResultRespList?.length === 1 && ( productPackageCalculateResultRespList?.length || 0 ) < 1) {

        // 砍价当前价格 等于 支付价格 即可认定 砍价是最低优惠或之一 走砍价
        if (bargainActualPrice == orderPayPrice) {
          this.promotionList = [
            {
              price: promotionInfo.couponDiscountPrice || 0,
              type: 'coupon',
              available: true,
              couponName: '',
              isRecommend:
                promotionInfo.couponId === this.couponInfo.recommend &&
                this.couponAllList.length &&
                promotionInfo.couponId,
            },
            {
              price: bargainDiscountPrice,
              type: 'bargain',
            },
          ]
          console.log('+++++++++++++++++++++', [...this.promotionList])
        }
        // 若上述情况下 接口反了优惠券信息 说明是极端情况 券后价 等于 砍后价 且选中了优惠券
        // 此时则不展示砍价
        if(promotionInfo.couponDiscountPrice > bargainDiscountPrice && promotionInfo.couponId){
          console.log('~~~~~~~~~~~~~~~~~~~~~~~')
          this.promotionList.pop()
        }
      }
      this.priceInfo.payable = promotionInfo.orderPayPrice?.toFixed(2);
      this.priceInfo.totalDiscount = (
        promotionInfo.orderTotalPrice - promotionInfo.orderPayPrice
      )?.toFixed(2);
    },
    async getPriceInfo(isInit = false, productSkus) {
      // 区分普通订单与拼团订单的计价接口
      if (this.routeQuery.groupActivityId) {
        this.groupGetPrice();
      } else {
        this.commonGetPrice(isInit, productSkus);
      }
    },
    async commonGetPrice(isInit = false, productSkus) {
      try {
        const selectedProductSkus = productSkus || JSON.parse(this.$route.query?.product || '[]');

        const params = {
          promotionBasicPrice: {
            endPoint: this.$root.$data.isApp ? 2 : 3,
            platform: 1,
          },
          promotionCouponPrice: {
            couponId: this.couponInfo.couponId || undefined,
            couponVersionId: this.couponInfo.couponVersion || undefined,
            useCoupon: this.couponInfo.useCoupon,
          },
        };
        const { cart } = this.$route.query;
        if (cart) {
          // 购物车多套餐购买
          params.promotionProductPackageReqList = selectedProductSkus;
        } else {
          // 正常
          const { packageId } = this.$route.query;
          if (packageId) {
            params.promotionProductPackageReqList = [
              {
                packageId,
                packageProductSkuReqList: selectedProductSkus.map((selectedProductSku) => ({
                  productId: selectedProductSku.productId,
                  skuId: selectedProductSku.skuId,
                })),
              },
            ];
          } else {
            params.promotionProductSkuPriceList = selectedProductSkus.map((selectedProductSku) => ({
              productId: selectedProductSku.productId,
              skuId: selectedProductSku.skuId,
            }));
          }
        }

        const responseJSON = await reqOrderPriceInfo(params);
        this.loading = false;
        if (responseJSON?.code) {
          throw new Error(responseJSON?.msg || '请求错误');
        }
        this.labelInfo = {
          single: responseJSON?.data?.singleCalculateResultRespList,
          union: responseJSON?.data?.unionCalculateResultRespList,
          fullReduction: responseJSON?.data?.promotionFullCalculateResultRespList,
        };
        this.labelCalc();
        if (isInit) {
          this.couponInfo.recommend = responseJSON?.data?.couponId;
          this.$forceUpdate();
        }
        if (!responseJSON?.data?.unionDiscountPrice) {
          this.isInUnion = false;
          this.reqUnionRecommend();
        } else {
          this.isInUnion = true;
          this.unionSelectable = false;
        }
        this.priceHandle(responseJSON?.data);
      } catch (e) {
        this.$toast(`因${e}获取促销活动错误`);
      }
    },

    async groupGetPrice() {
      const { groupActivityId, productId, skuId } = this.routeQuery;
      const param = {
        groupActivityId,
        productId,
        skuId,
        userId: this.$store.state.userInfo.id,
      };
      const res = await reqPostGroupPrice(param);
      this.loading = false;
      const { groupDiscountPrice, orderPayPrice } = res.data;
      this.priceInfoBox = res.data;
      this.promotionList = [
        {
          price: groupDiscountPrice,
          type: 'group',
        },
      ];
      this.priceInfo = {
        payable: String(orderPayPrice),
        totalDiscount: String(groupDiscountPrice),
      };
    },

    orderCommit() {
      if (!this.productList?.length) {
        this.$toast('正在初始化商品信息，请稍后重试');
        return;
      }

      if (this.orderCheckInfo.addressBeforeOrder && !this.addressInfo?.id) {
        this.$toast('请填写收货地址信息');
        return;
      }
      if (this.orderCheckInfo.repeatPurchaseProductId?.length) {
        this.$toast(
          `id为${(
            this.orderCheckInfo?.repeatPurchaseProductId || []
          ).join()}的产品不可重复购买,请重新下单`,
        );
        return;
      }
      this.orderCommitLoading = true;

      this.referer = '';
      if (sessionStorage.getItem('fromPageUrl')) {
        const paramData = JSON.parse(sessionStorage.getItem('fromPageUrl'));
        this.referer = paramData.fromPageUrl ? paramData.fromPageUrl : paramData.fromPageUrlLast;
      }

      // eslint-disable-next-line
      let uuid = gio('getVisitUserId') || [];
      // eslint-disable-next-line
      const sceneMap = JSON.parse(localStorage.getItem('sceneMap'));
      if (!this.$root.$data.isApp && sceneMap) {
        this.gioVisitUserId = `{u:'${uuid[0] || ''}', roomId: '${this.$route.query.liveRoomId || ''
          }',wechatSource:'${this.miniParams()}',entryMode:'${sceneMap?.name}',userSource:'${sceneMap?.source
          }',affiliatedTeacher:'${sceneMap?.teacher}'}`;
      }

      if (!this.$root.$data.isApp && !sceneMap) {
        this.gioVisitUserId = `{u:'${uuid[0] || ''}', roomId: '${this.$route.query.liveRoomId || ''
          }',wechatSource:'${this.miniParams()}'}`;
      }

      // 判断提交订单的活动方式
      // 存在groupId为参团，仅存在groupActivityId为开团，其他为普通订单
      if (this.routeQuery.groupOrderType === 'joinGroup') {
        this.joinGroupOrderCommit();
      } else if (this.routeQuery.groupOrderType === 'openGroup') {
        this.groupBuyOrderCommit();
      } else {
        this.commonOrderCommit();
      }
    },

    // 参加拼团提交
    async joinGroupOrderCommit() {
      const response = await reqPostGroupJoinCommit(
        {
          channelMark: 5,
          extendParam: this.gioVisitUserId,
          groupActivityId: this.routeQuery.groupActivityId,
          // eslint-disable-next-line no-undef
          ip: sessionStorage.getItem('cityIp') || '',
          orderReferer: this.referer,
          orderUrl: window.location.href,
          productId: this.routeQuery.productId,
          productSkuId: this.routeQuery.skuId,
          terminalMark: this.$global.terminalMark,
          userAddressId: this.addressInfo?.id || undefined,
          userId: this.$store.state.userInfo.id,
          orderSource: this.miniParams(),
        },
        this.routeQuery.groupId,
      );
      this.orderCommitCallback(response, 'joinGroupBuy');
    },

    // 抖音上报入参
    tiktokSetData() {
      const { product, remark, link } = this.$route.query;
      const products = JSON.parse(product).map((item) => ({
        productId: item.productId,
        quantity: 1,
        type: 1,
        productSkuId: item.skuId,
      }));
      // 抖音上报需要传递的参数
      // eslint-disable-next-line
      let uuid = gio('getVisitUserId') || [];
      const extendParam = `{eventType:'customer_effective',clickId:'${link}',u:'${uuid[0] || ''}'}`;
      const data = {
        channelMark: 5,
        couponId: this.couponAllList.find((coupon) => coupon.active)?.couponId,
        couponVersionId: this.couponInfo.couponVersionId || '',
        products,
        useCoupon: this.couponInfo.useCoupon,
        terminalMark: this.$global.terminalMark,
        userAddressId: this.addressInfo?.id || undefined,
        // eslint-disable-next-line no-undef
        ip: sessionStorage.getItem('cityIp') || '',
        orderReferer: this.referer,
        orderUrl: window.location.href,
        extendParam,
        orderSource: this.miniParams(),
        flowSource: 1,
        remark,
      };
      return data;
    },

    // 普通订单提交
    async commonOrderCommit() {
      let courses = [];
      const { packageId, type, cart } = this.$route.query;
      if (cart) {
        (JSON.parse(this.$route.query.product) || []).map((product) => {
          product.packageProductSkuReqList.map((item) => {
            courses.push({
              cartId: product.cartId,
              productId: item.productId,
              productSkuId: item.skuId,
              type: 1,
              quantity: 1,
              packageId: product.packageId,
              packageGroupId: item.packageGroupId,
            });
          });
        });
      } else if (!packageId) {
        courses = (this?.productList || []).map((product) => ({
          productId: product.productId,
          productSkuId: product.productSkuId,
          type: 1,
          quantity: 1,
        }));
        (JSON.parse(this.$route.query.product) || []).map((item) => {
          courses.map((val) => {
            if (item.skuId == val.productSkuId) {
              Object.assign(val, {
                cartId: item.cartId || '',
              });
            }
          });
        });
      } else {
        courses = (JSON.parse(this.$route.query.product) || []).map((product) => ({
          productId: product.productId,
          productSkuId: product.skuId,
          type: 1,
          quantity: 1,
          packageId: product.packageId,
          packageGroupId: product.packageGroupId,
        }));
      }

      const commonParams = {
        channelMark: 5,
        couponId: this.couponAllList.find((coupon) => coupon.active)?.couponId,
        couponVersionId: this.couponInfo.couponVersionId || '',
        products: courses,
        useCoupon: this.couponInfo.useCoupon,
        terminalMark: this.$global.terminalMark,
        userAddressId: this.addressInfo?.id || undefined,
        // eslint-disable-next-line no-undef
        ip: sessionStorage.getItem('cityIp') || '',
        orderReferer: this.referer,
        orderUrl: window.location.href,
        extendParam: this.gioVisitUserId,
        orderSource: this.miniParams(),
      };
      const response = await postOrderCommit(
        type === 'tiktok' ? this.tiktokSetData() : commonParams,
      );
      this.orderCommitCallback(response, '');
    },

    // 拼团提交订单
    async groupBuyOrderCommit() {
      const response = await postGroupCommit({
        channelMark: 5,
        extendParam: this.gioVisitUserId,
        groupActivityId: this.routeQuery.groupActivityId,
        // eslint-disable-next-line no-undef
        ip: sessionStorage.getItem('cityIp') || '',
        orderReferer: this.referer,
        orderUrl: window.location.href,
        productId: this.routeQuery.productId,
        productSkuId: this.routeQuery.skuId,
        terminalMark: this.$global.terminalMark,
        userAddressId: this.addressInfo?.id || undefined,
        userId: this.$store.state.userInfo.id,
        orderSource: this.miniParams(),
      });
      this.orderCommitCallback(response, 'groupBuy');
    },

    // 提交订单接口回调
    orderCommitCallback(response, source) {
      // console.log(response, source, 8);
      this.orderCommitLoading = false;
      if (response?.code) {
        this.$toast(response?.msg || '无法获取订单号');
        return;
      }
      let orderNo = '';
      // 不同活动取不同的值
      if (source === 'groupBuy' || source === 'joinGroupBuy') {
        orderNo = response?.data?.groupOrderNo;
      } else {
        orderNo = response?.data?.orderNo;
      }
      this.gioOrderId = orderNo;
      this.gioEvent();
      const { isApp = false } = this.$root.$data;
      sessionStorage.setItem('payable', Number(this.priceInfo.payable)); // 存订单价格
      // if (Number(this.priceInfo.payable) === 0) {
      //   this.$router.push({
      //     path: 'paySuccess',
      //     query: { orderNo },
      //   });
      //   return;
      // }
      if (isApp) {
        const param = {
          orderNo,
          type: source === 'groupBuy' || source === 'joinGroupBuy' ? 2 : '',
          groupId:
            source === 'groupBuy' || source === 'joinGroupBuy' ? response?.data?.groupId : '',
        };
        this.$sendToApp('payCenter', param, false);
        return;
      }
      if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/myCourse/cashier/cashier?orderNo=${orderNo}&source=${source === 'groupBuy' || source === 'joinGroupBuy' ? 2 : ''
            }&groupId=${source === 'groupBuy' || source === 'joinGroupBuy' ? response?.data?.groupId : ''
            }`,
        });
        return;
      }
      this.$router.push({
        path: '/cashier',
        query: {
          isOrderAddres: !!this.addressInfo?.id,
          orderNo,
          source: source === 'groupBuy' || source === 'joinGroupBuy' ? 2 : '',
          groupId:
            source === 'groupBuy' || source === 'joinGroupBuy' ? response?.data?.groupId : '',
        },
      });
    },
    goBackConfirm() {
      this.dialogShow = true;
      return false;
    },
    dialogClose() {
      this.dialogShow = false;
    },
    selectCoupon() {
      // if (!this.couponAllList.length) return;
      // this.couponAllList = [];
      this.couponSelectShow = true;
    },
    popupClose() {
      this.couponSelectShow = false;
    },
    addressSelect() {
      this.$router.push({
        path: '/personalCenter/address',
        query: {
          needBack: true,
        },
      });
    },

    couponSelect(couponInfo) {
      const currentSelected = this.couponAllList.find((coupon) => coupon.active) || {};
      this.promotionList.find((promotion) => promotion.type === COUPON_TYPE).couponName =
        couponInfo?.couponName;
      if (currentSelected === couponInfo) return;
      if (currentSelected) Object.assign(currentSelected, { active: false });
      Object.assign(couponInfo || {}, { active: true });
      this.couponName = this.couponInfo.couponName || '';
      this.popupClose();
      this.couponInfo = {
        useCoupon: !!couponInfo,
        ...couponInfo,
        recommend: this.couponInfo.recommend,
      };
      const { cart } = this.$route.query;
      if (cart) {
        const data = JSON.parse(this.$route.query.product);
        this.getPriceInfo(false, data);
      } else {
        this.getPriceInfo(
          false,
          this.productList.map((productSku) => ({
            productId: productSku.productId,
            skuId: productSku.productSkuId,
          })),
        );
      }
    },
    unionSelect() {
      this.$refs.jointPreferencesRef.show = true;
      this.unionSelectShow = true;
    },
    unionConfirm(products) {
      this.$refs.jointPreferencesRef.show = false;
      this.dataInit(false, products);
    },
    async getDeatil() {
      const { packageId } = this.$route.query;
      if (!packageId) {
        this.memberPackage = false;
        return;
      }
      const { code, data } = await reqCombinationDetail(packageId);
      if (code === 0) {
        this.packageDetail = data;
        this.memberPackage = data.type === 2;
      }
    },
    async getPackageName() {
      const { cart } = this.$route.query;
      if (!cart) return;
      const selectedProductSkus = JSON.parse(this.$route.query?.product || '[]');
      const packageIdList = [];
      selectedProductSkus.map((item) => {
        packageIdList.push(item.packageId);
      });
      const res = await reqPackageName(packageIdList.join());
      if (res.code === 0) {
        selectedProductSkus.map((item) => {
          // eslint-disable-next-line no-unused-expressions
          res?.data.map((val) => {
            if (item.packageId === val.packageId) {
              Object.assign(item, {
                courseName: val.name,
              });
            }
          });
          item.packageProductSkuReqList.map((product) => {
            this.productList.map((pro) => {
              if (product.skuId === pro.productSkuId) {
                Object.assign(product, {
                  product: pro,
                });
              }
            });
          });
        });
        this.packageList = selectedProductSkus;
      }
    },
    // 数组去重
    unlink(arr) {
      // eslint-disable-next-line no-shadow
      return arr.filter(
        (item, index, arr) =>
          // 当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
          // eslint-disable-next-line implicit-arrow-linebreak
          arr.indexOf(item, 0) === index,
      );
    },
    gioEvent() {
      // console.log(this.priceInfoBox, 'this.priceInfo;this.priceInfo;');
      const courseIdList = [];
      const courseNameList = [];
      const allianceId = [];
      const allianceName = [];
      const fullReductionId = [];
      const fullReductionName = [];
      const secondsKillNameList = [];
      const {
        orderPayPrice,
        orderTotalPrice,
        productPackageCalculateResultRespList, // 套餐
        fullDiscountPrice,
        unionDiscountPrice,
        unionCalculateResultRespList,
        productCalculateResultRespList,
        promotionFullCalculateResultRespList,
        singleCalculateResultRespList,
        couponDiscountPrice,
        couponId,
        couponType,
      } = this.priceInfoBox;
      // // 注：套餐与普通字段不同取productPackageCalculateResultRespList
      if (productPackageCalculateResultRespList) {
        productPackageCalculateResultRespList[0].packageDetailCalculateResultRespList.forEach(
          (element) => {
            courseIdList.push(element.productId);
            courseNameList.push(element.productName);
          },
        );
      }
      if (productCalculateResultRespList) {
        productCalculateResultRespList.forEach((element) => {
          courseIdList.push(element.productId);
          courseNameList.push(element.productName);
        });
      }
      if (unionDiscountPrice) {
        unionCalculateResultRespList.forEach((element) => {
          allianceId.push(element.promotionId);
          allianceName.push(element.promotionName);
        });
      }
      if (fullDiscountPrice) {
        promotionFullCalculateResultRespList.forEach((element) => {
          fullReductionId.push(element.promotionId);
          fullReductionName.push(element.promotionName);
        });
      }
      if (singleCalculateResultRespList) {
        singleCalculateResultRespList.forEach((element) => {
          if (element.promotionLabel === 2 || element.promotionLabel === 3) {
            secondsKillNameList.push(element.promotionName);
          }
        });
      }

      // eslint-disable-next-line no-undef
      gio('track', 'placeOrder_event', {
        orderId_var: this.gioOrderId, // 订单id
        orderAmount_var: orderTotalPrice, // 订单原价
        orderActualAmount_var: orderPayPrice, // 订单实付
        isAlliance_var: unionDiscountPrice ? '是' : '否', // 是否参加联报
        allianceId_var: unionDiscountPrice ? this.unlink(allianceId).toString() : null, // 联报活动ID
        allianceName_var: unionDiscountPrice ? this.unlink(allianceName).toString() : null, // 联报活动名称
        allianceDiscountAmount_var: unionDiscountPrice || null, // 联报优惠金额
        isSecondsKill_var: secondsKillNameList.length > 0 ? '是' : '否', // 是否参加秒杀
        secondsKillNameList_var:
          secondsKillNameList.length > 0 ? secondsKillNameList.toString() : null, // 秒杀活动名称列表
        isFullReduction_var: fullDiscountPrice ? '是' : '否', // 是否参加满减
        fullReductionId_var: fullDiscountPrice ? this.unlink(fullReductionId).toString() : null, // 满减活动ID
        fullReductionName_var: fullDiscountPrice ? this.unlink(fullReductionName).toString() : null, // 满减活动名称
        fullReductionAmount_var: fullDiscountPrice || null, // 满减优惠金额
        useCoupon_var: couponDiscountPrice ? '是' : '否', // 是否使用优惠券
        useCouponId_var: couponId ? couponId.toString() : null, // 所用优惠券ID
        useCouponType_var: couponType && couponType === 1 ? '满减' : '打折', // 所用优惠券类型
        couponAmount_var: couponDiscountPrice || null, // 优惠券优惠金额
        courseIdList_var: courseIdList.toString(), // 课程 ID 列表
        courseNameList_var: courseNameList.toString(), // 课程名称列表
        isDeliveryAddress_var:
          this.orderCheckInfo.needAddress && this.addressInfo?.id ? '是' : '否', // 是否有收货地址
        // urlLaunch_var: null, // 投放地址

        // isSpellGroup_var: null, // 是否拼团
        // spellGroupName_var: null, // 拼团活动名称
        platform_var: gioPlatform(),
      });
    },
    miniParams() {
      const miniBeforePageName = window.localStorage.getItem('miniBeforePageName');

      return statusTextMap[miniBeforePageName] || '';
    },
    hasAccommodationProduct(data) {
      const hasDirectAccommodation =
        data?.some((item) => item && item.isAccommodation === 1);
      this.hasDirectAccommodation = hasDirectAccommodation

    },
  },
  destroyed() {
    if (window.currentTimer) clearInterval(window.currentTimer);
    if (window.getServerTimer) clearInterval(window.getServerTimer);
    window.currentTimer = null;
    window.getServerTimer = null;
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      const param = sessionStorage.getItem('fromPageUrl')
        ? JSON.parse(sessionStorage.getItem('fromPageUrl'))
        : {};
      if (from.path === '/' && !sessionStorage.getItem('webLoadMode') === 'refresh') {
        // 判断专题页跳转
        param.fromPageUrl = '';
        param.fromPageUrlLast = document.referrer;
      } else if (!(from.path === '/' && sessionStorage.getItem('webLoadMode') === 'refresh')) {
        // 非刷新状态
        param.fromPageUrlLast = `${window.location.origin}${from.fullPath}`;
      }
      sessionStorage.setItem('fromPageUrl', JSON.stringify(param));
    });
  },
  beforeRouteLeave(to, from, next) {
    if (to.path !== '/registrationLogin') {
      // 离开时清除referer存储；除了去登录页
      sessionStorage.removeItem('fromPageUrl');
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
.inApp {
  padding-top: 20px !important;
}

.orderConfirm {
  width: 100%;
  height: 100%;
  padding-top: 101px;
  padding-bottom: 210px;
  background: #f9f9f9;
  user-select: none;

  .cardPart {
    position: relative;
    margin: 22px 36px 0;
    background: #fff;
    border-radius: 4px;

    .cardPartTitle {
      height: 98px;
      color: #333;
      font-weight: bold;
      font-size: 29px;
      line-height: 98px;
      border-bottom: 2px solid #f5f5f6;
    }
  }

  .unionPromotion {
    display: flex;
    align-items: center;
    height: 87px;
    padding: 0 36px;
    color: #333;
    font-weight: bold;
    font-size: 25px;
    line-height: 87px;
    cursor: pointer;

    .promotionName {
      display: inline-block;
      max-width: 540px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &::before {
      display: inline-block;
      box-sizing: border-box;
      height: 36px;
      margin-right: 14px;
      padding: 0 5px 0 7px;
      color: #ff6c02;
      font-size: 22px;
      line-height: 34px;
      border: 1px solid #ff6c02;
      border-radius: 4px;
      content: '联报优惠';
    }

    &::after {
      position: absolute;
      top: 50%;
      right: 20px;
      width: 43px;
      height: 43px;
      background: url('../../assets/img/payment/go_detail.png') no-repeat center;
      background-size: contain;
      transform: translateY(-50%);
      content: '';
    }
  }

  .productList,
  .promotion {
    padding: 0 36px;
  }

  .secondSKillTips {
    padding: 22px 36px;
    color: #999;
    font-weight: 400;
    font-size: 22px;
    line-height: 31px;
    text-align: right;
  }
}

::v-deep .couponCard .couponInfo .couponName {
  padding: 10px 0 10px 0;
}

::v-deep .van-hairline--top::after {
  display: none;
}
</style>
